// src/components/Header.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CTAButton from './CTAButton';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // For section links that scroll to sections
    const handleSectionClick = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        setIsMenuOpen(false);
    };

    return (
        <header className="header">
            <div className="container">
                <div className="header-inner">
                    <Link to="/" className="logo-container">
                        <img
                            src="/images/wblogo.png"
                            alt="Wade Bros Detailing"
                            className="logo-image"
                        />
                    </Link>

                    <button
                        className={`hamburger ${isMenuOpen ? 'is-active' : ''}`}
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    <nav className={`nav ${isMenuOpen ? 'is-active' : ''}`}>
                        <ul className="nav-list">
                            <li className="nav-item">
                                <button
                                    onClick={() => handleSectionClick('services')}
                                    className="nav-link"
                                >
                                    Services
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    onClick={() => handleSectionClick('gallery')}
                                    className="nav-link"
                                >
                                    Gallery
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    onClick={() => handleSectionClick('about')}
                                    className="nav-link"
                                >
                                    About
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    onClick={() => handleSectionClick('contact')}
                                    className="nav-link"
                                >
                                    Contact
                                </button>
                            </li>
                            <li className="nav-item">
                                <CTAButton text="Get a Quote" size="small" />
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Header;